// Hook para obtener los teams disponibles para el submenú de Empresa

import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services/ApiClient';
import { useAuthStore } from '@shared/stores/authStore';
import { useQuery } from '@tanstack/react-query';
import React from 'react';

type MenuTeam = {
  id: number;
  name: string;
};

export const useMenuTeams = () => {
  const httpClient = createHttpClient(apiClientWH);
  const token = useAuthStore((s) => s.token);

  const {
    data: teamsResponse,
    isLoading,
    error,
    refetch,
  } = useQuery({
    queryKey: ['menu-teams'],
    queryFn: async () => httpClient.get<MenuTeam[]>('/teams'),
    staleTime: 5 * 60 * 1000, // 5 minutos
    gcTime: 10 * 60 * 1000, // 10 minutos
    enabled: !!token, // solo con sesión
  });

  // 🎯 Memoizar teams para evitar re-renders innecesarios
  // 🎯 Patrón similar a otros adapters: manejar array directo o objeto con data
  const teams = React.useMemo(() => {
    if (!teamsResponse) {
      return [];
    }
    
    // 🎯 Si es un array directo, usarlo
    const list = Array.isArray(teamsResponse)
      ? teamsResponse
      : Array.isArray((teamsResponse as any)?.data)
        ? (teamsResponse as any).data
        : [];
    
    // 🎯 Mapear a MenuTeam asegurando que tengan id y name
    return list
      .filter((item: any) => item && item.id && item.name)
      .map((item: any) => ({
        id: item.id,
        name: item.name,
      }));
  }, [teamsResponse]);

  return {
    teams,
    isLoading,
    error: error?.message || null,
    refetch,
  };
};
